import { useEffect, useState } from "react";
import { BrandLogo } from "@/components/Brand";
import { WhatsAppInbox, DEVICE_KEY } from "@/components/WhatsAppInbox";

export default function WhatsAppDevicePage() {
  const [ok, setOk] = useState(null);
  useEffect(() => {
    const d = new URLSearchParams(window.location.search).get("d");
    if (d) {
      localStorage.setItem(DEVICE_KEY, d);
      window.history.replaceState(null, "", "/whatsapp");
    }
    setOk(!!localStorage.getItem(DEVICE_KEY));
  }, []);
  if (ok === null) return null;
  return (
    <div className="min-h-screen bg-[#f8faf5]">
      <header className="flex items-center justify-between border-b bg-white px-5 py-3">
        <BrandLogo />
        <span className="text-sm font-semibold text-[#128C7E]">WhatsApp aziendale</span>
      </header>
      <main className="p-3 sm:p-5" data-testid="wa-device-page">
        {ok ? <WhatsAppInbox device /> : <p className="p-6 text-center text-sm text-slate-500" data-testid="wa-device-missing">Dispositivo non collegato. Apri il link di collegamento creato dall'amministratore.</p>}
      </main>
    </div>
  );
}
